import { apiFetch } from "./client";

export const fetchMembershipData = () =>
  apiFetch("/enduser/membership/", {
    credentials: "include",
  });

export const fetchProfileDashboard = () =>
  apiFetch("/enduser/profile-dashboard/", {
    credentials: "include",
  });

export const submitMembershipRequest = (payload) =>
  apiFetch("/enduser/membership/request/", {
    method: "POST",
    credentials: "include",
    body: payload,
  });

export const createMembershipOrder = (payload) =>
  apiFetch("/enduser/membership/create-order/", {
    method: "POST",
    credentials: "include",
    body: payload,
  });
